import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, Subscription } from 'rxjs';
import { BannerPublicidad } from 'src/app/model/http/banner.model';
import { StrappiService } from 'src/app/services/strappi.service';
import { Endpoints } from 'src/environments/endpoints';
import { environment } from 'src/environments/environment';
import { Location } from '@angular/common';


@Component({
  selector: 'app-banner-publicidad',
  templateUrl: './banner-publicidad.component.html',
  styleUrls: ['./banner-publicidad.component.scss']
})
export class BannerPublicidadComponent implements OnInit, OnDestroy {


  templateSuffix!: string;
  bannerPublidiadData!: BannerPublicidad;
  private subscription!: Subscription;
  basepath: string = Endpoints.strappi.base;
  isFordPath: boolean = false;
  private currentUrl: string = '';

  constructor(
    private readonly strappiService: StrappiService,
    private readonly router: Router,
    private readonly location: Location
  ) {
    this.templateSuffix = environment.templateSuffix;
  }


  ngOnInit(): void {
    this.loadBannerData();

    //? Suscribirse a los eventos de navegación del router para obtener la URL actual
    this.subscription = this.router.events.pipe(
      filter((event:any) => event instanceof NavigationEnd)
    ).subscribe((event: any) => {
      this.currentUrl = event.url;
      this.isFordPath = this.checkIfFordPath(this.currentUrl); 
    });

    
    this.currentUrl = this.location.path();
    this.isFordPath = this.checkIfFordPath(this.currentUrl); 

  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  /**
   * @description  Cargar la data del banner de publicidad desde Strappi. 
   * Este método se suscribe a la respuesta de la API y asigna los datos del banner a la variable `bannerPublidiadData`.
   * @private
   * @memberof BannerPublicidadComponent
   * @returns {void}
   * @author victor.mendez
   * 
   */
  private loadBannerData(): void {
    this.subscription = this.strappiService.getImagesGeneral().subscribe({
      next: (res: any) => {
        const bannerBuscadorItem = res.imagenes_general.find((item: any) => item.tipo === 'banner_buscador');
        this.bannerPublidiadData = bannerBuscadorItem;
      },
      error: (error: any) => {
        console.error('Error al obtener la data de strappi:', error);
        this.bannerPublidiadData = {} as BannerPublicidad;
      }
    }
    );
  }

  /**
   * @description  Revisa si la URL contiene 'ford' o 'territory' (sin importar mayúsculas o minúsculas).
   * Esto se utiliza para determinar si la URL pertenece a un banner específico.
   * @private
   * @param {string} url
   * @return {*}  {boolean}
   * @memberof BannerPublicidadComponent
   * @author victor.mendez
   */
  private checkIfFordPath(url: string): boolean {
    if (!url) {
      return false; 
    }
    const lowerCaseUrl = url.toLowerCase();
    return lowerCaseUrl.includes('ford/territory');
  }




}
